<script>
    import clickOutside from "../../lib/svelte_click_outside";
    import {fadeScale} from "../../lib/svelte_custom_transitions";
    import {cubicIn, cubicOut} from 'svelte/easing';
    import {user} from "../stores/user";

    export let auth_state;

    let show = false; // menu state

    const handleOutsideClick = e => {
        if(show) {
            show = false;
        }
    };
</script>

{#if !$user.logged_in}
<!-- Default external page -->
    <!--<a href="/api/auth/signin" rel="external" class="relative inline-flex items-center rounded-md border border-transparent bg-indigo-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-800">-->
<!-- Custom internal page -->
    <a href="/signin" class="relative inline-flex items-center rounded-md border border-transparent bg-indigo-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-800">
    <!-- Heroicon name: mini/plus -->
    <svg class="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
    </svg>
    <span>Sign In</span>
</a>
{:else}
<!-- Profile dropdown -->
<div class="flex items-center">
    <div class="hidden md:ml-4 md:flex md:flex-shrink-0 md:items-center">
        <button type="button" class="rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
            <span class="sr-only">View notifications</span>
            <!-- Heroicon name: outline/bell -->
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
            </svg>
        </button>

        <div class="relative ml-3" use:clickOutside={handleOutsideClick}>
            <div>
                <button on:click={() => show = !show}
                        type="button" class="flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800" id="user-menu-button" aria-expanded="false" aria-haspopup="true">
                    <span class="sr-only">Open user menu</span>
                    <img class="h-8 w-8 rounded-full" src="{$user.image}" alt="">
                </button>
            </div>

            <!--
              Dropdown menu, show/hide based on menu state.

              Entering: "transition ease-out duration-200"
                From: "transform opacity-0 scale-95"
                To: "transform opacity-100 scale-100"
              Leaving: "transition ease-in duration-75"
                From: "transform opacity-100 scale-100"
                To: "transform opacity-0 scale-95"
            -->
            {#if show}
                <div in:fadeScale={{duration: 100, easing: cubicIn, base_scale: 0.75}}
                     out:fadeScale={{duration: 100, easing:cubicOut, base_scale: 0.75}}
                     class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="user-menu-button" tabindex="-1">
                    <!-- Active: "bg-gray-100", Not Active: "" -->
                    <a href="/profile" class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-0">Your Profile</a>

                    <a href="/settings" class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-1">Settings</a>

                    <form action="/api/auth/signout" method="POST">
                        <input type="hidden" name="csrfToken" value="{auth_state.csrf}">
                        <button id="submitButton" type="submit" class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1">Sign out</button>
                    </form>
<!--                    <a href="/api/auth/signout" rel="external" class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-2">Sign out</a>-->
                </div>
            {/if}
        </div>
    </div>
</div>
{/if}

<!-- Profile dropdown--
<div class="ml-3 relative" use:clickOutside={handleOutsideClick}>
    <div class="flex">
        {#if user.signed_in}
        <button
            on:click={() => show = !show}
            class="max-w-xs flex items-center text-sm rounded-full focus:outline-none focus:shadow-outline" id="user-menu" aria-label="User menu" aria-haspopup="true">
            <img class="h-8 w-8 rounded-full" src="{user.img}" alt="">
        </button>
        {:else if user.fetching}
            <p>Fetching!</p>
        {:else}
            <button on:click={() => navigateTo(user, 'register')} class="flex justify-center py-2 px-4 mr-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Sign Up</button>
            <button on:click={() => navigateTo(user, 'login')} class="flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Login</button>
        {/if}
    </div>

    {#if show}
        {#if user.signed_in}
            <div in:fadeScale={{duration: 100, easing: cubicIn, base_scale: 0.75}}
                 out:fadeScale={{duration: 100, easing:cubicOut, base_scale: 0.75}}
                 class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg">
                <div class="py-1 rounded-md bg-white shadow-xs" role="menu" aria-orientation="vertical" aria-labelledby="user-menu">
                    <a href="#foo" on:click|preventDefault={() => navigateTo(user, 'user-edit')} class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150" role="menuitem">Edit Profile</a>
                    <a href="#foo" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150" role="menuitem">Settings</a>
                    <a href="#foo" on:click|preventDefault={doLogout} class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150" role="menuitem">Sign out</a>
                </div>
            </div>
        {/if}
    {/if}
</div>
-->

<style>

</style>